import { render } from "./checkItem.vue?vue&type=template&id=36769a91&scoped=true&ts=true"
import script from "./checkItem.vue?vue&type=script&lang=ts"
export * from "./checkItem.vue?vue&type=script&lang=ts"

import "./checkItem.vue?vue&type=style&index=0&id=36769a91&scoped=true&lang=less"
import "./checkItem.vue?vue&type=style&index=1&id=36769a91&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36769a91"]])

export default __exports__